import Video from 'app/components/tv/models/video';

const START_TIME = 0;
const VIDEO_DURATION = 20;

export default class YousportVideo extends Video {
  get startTime(): number {
    return START_TIME;
  }

  get videoDuration(): number {
    return VIDEO_DURATION;
  }

  manuallyEndAt(): number | null {
    return null;
  }

  showFuPaTvLogo(): boolean {
    return false;
  }
}
